import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ExcelDownloadIcon from "assets/images/ExcelDownload.png";
import DownloadFileIcon from "components/SVGs/DownloadFile";
import Button from "components/Button";
import { utils, writeFile } from "xlsx";

export const sheetColumns = [
  "student id",
  "student name",
  "student email",
  "className",
];

function DownloadSample() {
  const { t } = useTranslation();
  const downloadHandler = () => {
    const studentDetailsSheet = utils.aoa_to_sheet([
      sheetColumns.map((col) => t(col)),
    ]);
    studentDetailsSheet["!cols"] = [
      { wch: 20 },
      { wch: 20 },
      { wch: 30 },
      { wch: 20 },
    ];
    const sampleExcelSheet = utils.book_new();
    utils.book_append_sheet(
      sampleExcelSheet,
      studentDetailsSheet,
      "student-details"
    );
    writeFile(sampleExcelSheet, "student_list_sample.xlsx");
  };

  return (
    <Typography
      component="div"
      sx={{
        width: "100%",
        height: "54px",
        backgroundColor: "rgb(248 248 248)",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <Typography
        component="div"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 15px",
          userSelect: "none",
        }}
      >
        <img
          src={ExcelDownloadIcon}
          style={{ width: "22px", height: "30px" }}
          alt="students upload sample excel"
        />
        <Typography
          component="span"
          sx={{
            padding: "0 5px",
            color: "rgb(105 123 140)",
            fontSize: "12px",
            fontWeight: "bold",
          }}
        >
          student_list_sample.XLSX
        </Typography>
      </Typography>
      <Button
        label={t("Download file")}
        action={downloadHandler}
        styles={{
          width: "150px",
          margin: "5px 10px",
          fontSize: "12px",
          fontWeight: "bold",
        }}
        Icon={<DownloadFileIcon sx={{ width: "28px", padding: "0 5px" }} />}
      />
    </Typography>
  );
}

export default DownloadSample;
